export const DividerIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 82.5C53 80.0147 55.0147 78 57.5 78H228.5C230.985 78 233 80.0147 233 82.5C233 84.9853 230.985 87 228.5 87H57.5C55.0147 87 53 84.9853 53 82.5Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 105.5C53 103.015 55.0147 101 57.5 101H298.5C300.985 101 303 103.015 303 105.5C303 107.985 300.985 110 298.5 110H57.5C55.0147 110 53 107.985 53 105.5Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 128.5C53 126.015 55.0147 124 57.5 124H268.5C270.985 124 273 126.015 273 128.5C273 130.985 270.985 133 268.5 133H57.5C55.0147 133 53 130.985 53 128.5Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M347 164H53V162H347V164Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 197.5C53 195.015 55.0147 193 57.5 193H268.5C270.985 193 273 195.015 273 197.5C273 199.985 270.985 202 268.5 202H57.5C55.0147 202 53 199.985 53 197.5Z'
      fill='#A0AEC0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53 220.5C53 218.015 55.0147 216 57.5 216H228.5C230.985 216 233 218.015 233 220.5C233 222.985 230.985 225 228.5 225H57.5C55.0147 225 53 222.985 53 220.5Z'
      fill='#A0AEC0'
    />
  </svg>
)
